<section class="content overtime-page">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
        [items]="[('overtimesCatalog.breadcrumb' | translate)]"
        [active_item]="'overtimesCatalog.detail.breadcrumb' | translate">
      </app-breadcrumb>
    </div>

    <div class="overtime-detail-workspace" [class.overtime-detail-workspace--loading]="isLoading">
      <div #detailBody class="overtime-detail-scroll">
        @if (selectedOvertime; as overtime) {
          <article class="overtime-detail">
            <mat-card class="overtime-card overtime-hero">
              <div class="overtime-hero__identity">
                <div class="employee-avatar" aria-hidden="true">{{ employeeInitials }}</div>
                <div class="overtime-hero__copy">
                  <div class="overtime-hero__title-row">
                    <h1>{{ overtime.employeeLabel }}</h1>
                    <span class="overtime-status"
                          [class.overtime-status--approved]="overtime.status === 'approved'"
                          [class.overtime-status--rejected]="overtime.status === 'rejected'">
                      <mat-icon>{{ statusIcon }}</mat-icon>{{ overtime.statusLabel }}
                    </span>
                  </div>
                  <div class="employee-meta">
                    <span><mat-icon>badge</mat-icon>{{ overtime.employeeNumber || '-' }}</span>
                    <i></i>
                    <span><mat-icon>apartment</mat-icon>{{ overtime.companyName || '-' }}</span>
                    <i></i>
                    <span><mat-icon>business_center</mat-icon>{{ overtime.orgUnitName || '-' }}</span>
                  </div>
                </div>
              </div>

              <div class="overtime-panel__actions">
                @if (canResolve) {
                  <button mat-flat-button color="primary" type="button" (click)="approveSelected()">
                    <mat-icon>check_circle</mat-icon>
                    {{ 'overtimesCatalog.actions.approve' | translate }}
                  </button>
                  <button mat-stroked-button color="warn" type="button" (click)="rejectSelected()">
                    <mat-icon>cancel</mat-icon>
                    {{ 'overtimesCatalog.actions.reject' | translate }}
                  </button>
                }
                @if (canDelete) {
                  <button mat-stroked-button color="warn" type="button" (click)="deleteSelected()">
                    <mat-icon>delete</mat-icon>
                    {{ 'overtimesCatalog.actions.delete' | translate }}
                  </button>
                }
                <button mat-stroked-button type="button" class="btn-tone-neutral" (click)="goBackToList()">
                  <mat-icon>arrow_back</mat-icon>
                  {{ 'common.back' | translate }}
                </button>
              </div>
            </mat-card>

            <mat-card class="overtime-card summary-card">
              <div class="compact-heading">
                <div class="compact-heading__icon"><mat-icon>calendar_month</mat-icon></div>
                <h2>{{ 'overtimesCatalog.sections.summary' | translate }}</h2>
              </div>
              <div class="summary-metrics">
                <div class="summary-metric summary-metric--date">
                  <div class="summary-metric__icon"><mat-icon>calendar_month</mat-icon></div>
                  <div>
                    <span>{{ 'overtimesCatalog.fields.workDate' | translate }}</span>
                    <strong>{{ overtime.workDateLabel }}</strong>
                    <small>{{ workDayLabel }}</small>
                  </div>
                </div>
                <div class="summary-metric summary-metric--time">
                  <div class="summary-metric__icon"><mat-icon>schedule</mat-icon></div>
                  <div>
                    <span>{{ 'overtimesCatalog.fields.detectedMinutes' | translate }}</span>
                    <strong>{{ overtime.detectedMinutesLabel }}</strong>
                    <small>{{ detectedHoursLabel }}</small>
                  </div>
                </div>
              </div>
            </mat-card>

            <div class="overtime-grid">
              <mat-card class="overtime-card section-card">
                <div class="section-heading">
                  <div class="section-heading__icon"><mat-icon>description</mat-icon></div>
                  <div>
                    <h2>{{ 'overtimesCatalog.sections.recordInformation' | translate }}</h2>
                    <p>{{ 'overtimesCatalog.sections.recordInformationDescription' | translate }}</p>
                  </div>
                </div>
                <dl class="information-list">
                  <div>
                    <dt>{{ 'overtimesCatalog.fields.requestedBy' | translate }}</dt>
                    <dd>{{ overtime.requestedByName || overtime.requestedByUid || '-' }}<mat-icon class="copy-icon">content_copy</mat-icon></dd>
                  </div>
                  <div><dt>{{ 'overtimesCatalog.fields.requestedAt' | translate }}</dt><dd>{{ overtime.requestedAtLabel }}</dd></div>
                  <div class="information-list__origin">
                    <dt>{{ 'overtimesCatalog.fields.origin' | translate }}</dt>
                    <dd><strong>{{ 'overtimesCatalog.labels.system' | translate }}</strong><span>{{ 'overtimesCatalog.history.createdDescription' | translate }}</span></dd>
                  </div>
                </dl>
              </mat-card>

              <mat-card class="overtime-card section-card resolution-section">
                <div class="section-heading">
                  <div class="section-heading__icon"><mat-icon>settings</mat-icon></div>
                  <div>
                    <h2>{{ 'overtimesCatalog.sections.statusResolution' | translate }}</h2>
                    <p>{{ 'overtimesCatalog.sections.resolutionDescription' | translate }}</p>
                  </div>
                </div>
                <div class="current-status"
                     [class.current-status--approved]="overtime.status === 'approved'"
                     [class.current-status--rejected]="overtime.status === 'rejected'">
                  <div class="current-status__icon"><mat-icon>{{ statusIcon }}</mat-icon></div>
                  <div>
                    <span>{{ 'overtimesCatalog.detail.currentStatus' | translate }}</span>
                    <strong>{{ ('overtimesCatalog.history.' + (overtime.status || 'pending')) | translate }}</strong>
                    <p>{{ ('overtimesCatalog.history.' + (overtime.status || 'pending') + 'Description') | translate }}</p>
                  </div>
                </div>
                <dl class="resolution-grid">
                  <div><dt>{{ 'overtimesCatalog.fields.approvedMinutes' | translate }}</dt><dd>{{ overtime.approvedMinutesLabel }}</dd></div>
                  <div><dt>{{ 'overtimesCatalog.fields.resolvedBy' | translate }}</dt><dd>{{ overtime.resolvedByName || overtime.resolvedByUid || '-' }}</dd></div>
                  <div><dt>{{ 'overtimesCatalog.fields.resolvedAt' | translate }}</dt><dd>{{ overtime.resolvedAtLabel }}</dd></div>
                  <div class="resolution-grid__comment"><dt>{{ 'overtimesCatalog.fields.resolutionComment' | translate }}</dt><dd>{{ overtime.resolutionComment || '-' }}</dd></div>
                </dl>
              </mat-card>

              <mat-card class="overtime-card section-card history-section">
                <div class="section-heading">
                  <div class="section-heading__icon"><mat-icon>view_timeline</mat-icon></div>
                  <div>
                    <h2>{{ 'overtimesCatalog.sections.history' | translate }}</h2>
                    <p>{{ 'overtimesCatalog.sections.historyDescription' | translate }}</p>
                  </div>
                </div>
                <div class="timeline">
                  @for (entry of historyTimeline; track $index) {
                    <div class="timeline-item" [class.timeline-item--primary]="entry.primary">
                      <span class="timeline-item__dot"></span>
                      <div><strong>{{ entry.title }}</strong><span>{{ entry.date }}</span></div>
                      <div><strong class="actor-pill">{{ entry.actor }}</strong><span>{{ entry.description }}</span></div>
                    </div>
                  }
                </div>
              </mat-card>

              <mat-card class="overtime-card section-card technical-section">
                <details class="section-disclosure" open>
                  <summary>
                    <div class="section-heading section-heading--summary">
                      <div class="section-heading__icon"><mat-icon>storage</mat-icon></div>
                      <div>
                        <h2>{{ 'overtimesCatalog.sections.technical' | translate }}</h2>
                        <p>{{ 'overtimesCatalog.sections.technicalDescription' | translate }}</p>
                      </div>
                    </div>
                    <mat-icon class="disclosure-icon">expand_more</mat-icon>
                  </summary>
                  <dl class="technical-list">
                    <div><dt>{{ 'overtimesCatalog.fields.recordId' | translate }}</dt><dd>{{ overtime.overtimeId }}<mat-icon>content_copy</mat-icon></dd></div>
                    <div><dt>{{ 'overtimesCatalog.fields.requestId' | translate }}</dt><dd>{{ overtime.requestedByUid || '-' }}<mat-icon>content_copy</mat-icon></dd></div>
                    <div><dt>{{ 'overtimesCatalog.fields.orgUnit' | translate }}</dt><dd>{{ overtime.orgUnitName || '-' }}</dd></div>
                    <div><dt>{{ 'overtimesCatalog.fields.company' | translate }}</dt><dd>{{ overtime.companyName || '-' }}</dd></div>
                    <div><dt>{{ 'overtimesCatalog.fields.attendanceResult' | translate }}</dt><dd>{{ overtime.attendanceResultId || '-' }}</dd></div>
                  </dl>
                </details>
              </mat-card>
            </div>
          </article>
        } @else if (!isLoading) {
          <div class="overtime-card overtime-empty">
            <mat-icon>schedule</mat-icon>
            <h2>{{ 'overtimesCatalog.emptyEditorTitle' | translate }}</h2>
            <p>{{ 'overtimesCatalog.emptyEditorDescription' | translate }}</p>
          </div>
        }
      </div>

      @if (isLoading) {
        <app-loading-state class="overtime-loading" [message]="'overtimesCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
